export default {"src":"/_next/static/media/expired-icon.1454b27e.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};